'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { useLocale, useTranslations } from 'next-intl';
import { toast } from 'sonner';
import { authClient, signIn } from '@/core/auth/client';
import { Link, useRouter } from '@/core/i18n/navigation';
import { defaultLocale } from '@/config/locale';
import { Button } from '@/shared/components/ui/button';
import { Input } from '@/shared/components/ui/input';
import { Label } from '@/shared/components/ui/label';
import { useAppContext } from '@/shared/contexts/app';
import { SocialProviders } from './social-providers';
export function SignInForm(t0) {
  const $ = _c(35);
  const {
    callbackUrl: t1,
    className
  } = t0;
  let callbackUrl = t1 === undefined ? "/" : t1;
  const t = useTranslations("common.sign");
  const router = useRouter();
  const locale = useLocale();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const {
    configs
  } = useAppContext();
  const isGoogleAuthEnabled = configs.google_auth_enabled === "true";
  const isGithubAuthEnabled = configs.github_auth_enabled === "true";
  const isEmailAuthEnabled = configs.email_auth_enabled !== "false" || !isGoogleAuthEnabled && !isGithubAuthEnabled;
  if (callbackUrl) {
    if (locale !== defaultLocale && callbackUrl.startsWith("/") && !callbackUrl.startsWith(`/${locale}`)) {
      callbackUrl = `/${locale}${callbackUrl}`;
    }
  }
  const base = locale !== defaultLocale ? `/${locale}` : "";
  let t2;
  if ($[0] !== locale) {
    t2 = path => {
      if (!path?.startsWith("/")) {
        return "/";
      }
      if (locale === defaultLocale) {
        return path;
      }
      if (path === `/${locale}`) {
        return "/";
      }
      if (path.startsWith(`/${locale}/`)) {
        return path.slice(locale.length + 1) || "/";
      }
      return path;
    };
    $[0] = locale;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const stripLocalePrefix = t2;
  let t3;
  if ($[2] !== base || $[3] !== callbackUrl || $[4] !== email || $[5] !== loading || $[6] !== password || $[7] !== router || $[8] !== setLoading || $[9] !== stripLocalePrefix) {
    t3 = async () => {
      if (loading) {
        return;
      }
      if (!email || !password) {
        toast.error("email and password are required");
        return;
      }
      setLoading(true);
      ;
      try {
        await signIn.email({
          email,
          password,
          callbackURL: callbackUrl
        }, {
          onRequest: _temp,
          onResponse: _temp2,
          onSuccess: _temp3,
          onError: e_0 => {
            const status = e_0?.error?.status;
            if (status === 403) {
              const normalizedCallbackUrl = stripLocalePrefix(callbackUrl);
              const verifyPath = `/verify-email?sent=1&email=${encodeURIComponent(email)}&callbackUrl=${encodeURIComponent(normalizedCallbackUrl)}`;
              authClient.sendVerificationEmail({
                email,
                callbackURL: `${base}${verifyPath}`
              });
              router.push(verifyPath);
              return;
            }
            toast.error(e_0?.error?.message || "sign in failed");
            setLoading(false);
          }
        });
      } catch (t4) {
        const e = t4;
        toast.error(e?.message || "sign in failed");
        setLoading(false);
      }
    };
    $[2] = base;
    $[3] = callbackUrl;
    $[4] = email;
    $[5] = loading;
    $[6] = password;
    $[7] = router;
    $[8] = setLoading;
    $[9] = stripLocalePrefix;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const handleSignIn = t3;
  const t4 = `w-full md:max-w-md ${className}`;
  let t5;
  if ($[11] !== email || $[12] !== handleSignIn || $[13] !== isEmailAuthEnabled || $[14] !== loading || $[15] !== password || $[16] !== setEmail || $[17] !== setPassword || $[18] !== t) {
    t5 = isEmailAuthEnabled && <form className="grid gap-4" onSubmit={e_1 => {
      e_1.preventDefault();
      handleSignIn();
    }}><div className="grid gap-2"><Label htmlFor="email">{t("email_title")}</Label><Input id="email" type="email" placeholder={t("email_placeholder")} required={true} onChange={e_2 => {
          setEmail(e_2.target.value);
        }} value={email} /></div><div className="grid gap-2"><Input id="password" type="password" placeholder={t("password_placeholder")} autoComplete="password" value={password} onChange={e_3 => setPassword(e_3.target.value)} required={true} /></div><Button type="submit" className="w-full" disabled={loading}>{loading ? <Loader2 size={16} className="animate-spin" /> : <p> {t("sign_in_title")} </p>}</Button></form>;
    $[11] = email;
    $[12] = handleSignIn;
    $[13] = isEmailAuthEnabled;
    $[14] = loading;
    $[15] = password;
    $[16] = setEmail;
    $[17] = setPassword;
    $[18] = t;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  const t6 = callbackUrl || "/";
  let t7;
  if ($[20] !== configs || $[21] !== loading || $[22] !== setLoading || $[23] !== t6) {
    t7 = <SocialProviders configs={configs} callbackUrl={t6} loading={loading} setLoading={setLoading} />;
    $[20] = configs;
    $[21] = loading;
    $[22] = setLoading;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== t5 || $[26] !== t7) {
    t8 = <div className="grid gap-4">{t5}{t7}</div>;
    $[25] = t5;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== isEmailAuthEnabled || $[29] !== t) {
    t9 = isEmailAuthEnabled && <div className="flex w-full justify-center border-t py-4"><p className="text-center text-xs text-neutral-500">{t("no_account")}<Link href="/sign-up" className="underline"><span className="cursor-pointer dark:text-white/70">{t("sign_up_title")}</span></Link></p></div>;
    $[28] = isEmailAuthEnabled;
    $[29] = t;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== t4 || $[32] !== t8 || $[33] !== t9) {
    t10 = <div className={t4}>{t8}{t9}</div>;
    $[31] = t4;
    $[32] = t8;
    $[33] = t9;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  return t10;
}
function _temp3(ctx_1) {}
function _temp2(ctx_0) {}
function _temp(ctx) {}